import { useBoundStore } from '@/store/store';

import { trpcUtils } from './trpc';

export function invalidateCurrentOrganization(organizationId: string) {
  if (organizationId === useBoundStore.getState().currentOrganizationId) {
    return trpcUtils.organizations.getCurrent.invalidate();
  }

  return Promise.resolve();
}
